import { FC } from 'react'
import { ContractProps } from './ContractHtml'
import Letterhead from './Letterhead'

const placeholder = (value?: string | null) => value?.trim() || '-----------'

const Page2: FC<ContractProps> = ({ data, category }) => {
  return (
    <Letterhead data={data} pageNumber={2}>
      <p className="text-lg font-bold">ماده ۴)</p>
      <p className="mb-2 text-lg font-bold">مدت قرارداد</p>
      <p className="text">
        مدت این قرارداد از تاریخ{' '}
        <span className="font-bold">1405/07/21</span> لغایت پایان{' '}
        <span className="font-bold">1405/09/30</span> شمسی خواهد بود و در صورت
        رضایت طرفین و عدم اعلام کتبی انصراف توسط هریک از طرفین، این قرارداد برای
        مدت ۶ ماه تمدید شده تلقی می‌گردد. برای تمدیدهای بعدی نیز به همین ترتیب
        اقدام خواهد شد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۵)</p>
      <p className="mb-2 text-lg font-bold">مبلغ قرارداد</p>
      <p className="text">
        ۱-۵ عضویت در شبکه پذیرندگان اعتباری آپولون رایگان می‌باشد. شایان‌ذکر است
        که درصد کمیسیون و کارمزد توافق شده در بند ۲ ماده ۵ نسبت به کل مبلغ فاکتور
        محاسبه می‌گردد. بانک اطلاعاتی و سیستم‌های آنلاین آپولون مشخص‌کننده مبالغ
        مورد مطالبه می‌باشند و در صورت اختلاف در مبلغ مطالبات، بانک اطلاعاتی و
        سیستم‌های آنلاین آپولون ملاک محاسبه است.
      </p>
      <p className="text">
        ۲-۵ پذیرنده موافقت خود را جهت پرداخت{' '}
        <span className="font-bold">
          {placeholder(category?.commission_percentage)}%
        </span>{' '}
        به عنوان کمیسیون و کارمزد برای سفارشاتی که از طریق درگاه اعتباری آپولون
        پرداخت می گردد اعلام می نماید. این میزان کمیسیون تا زمانی اعمال می‌شود
        که پذیرنده کلیه شرایط و ضوابط و تعهدات قراردادی خود را بطور کامل رعایت
        نماید.
      </p>
      <p className="text">
        ۳-۵ آپولون می تواند در صورت تغییر دسته‌بندی کالا میزان کمیسیون را تغییر
        داده و مراتب را به پذیرنده اعلام نماید.
      </p>
      <p className="text">
        ۴-۵ درصد کمیسیون و کارمزد ذکرشده پیش از محاسبه مالیات بر ارزش‌افزوده می
        باشد. مبلغ مالیات بر ارزش‌افزوده طبق قوانین جمهوری اسلامی ایران محاسبه
        شده که به‌کل مبلغ کمیسیون و کارمزد تعلق می گیرد و به صورتحساب ارسالی
        صادره از سوی آپولون اضافه خواهد شد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۶)</p>
      <p className="mb-2 text-lg font-bold">شرایط پرداخت</p>
      <p className="text">
        ۱-۶ آپولون موظف است مجموع کلیه مبالغ خرید اعتباری کاربران از پذیرنده که
        از طریق سرویس اعتباری انجام شده را پس از کسر مبلغ کمیسیون و کارمزد توافق
        شده، با پذیرنده تسویه نماید و صورتحساب کمیسیون و کارمزد خود را به صورت
        ماهانه صادر و در سامانه مودیان ثبت و نسخه فیزیکی آن را در صورت درخواست
        برای پذیرنده ارسال نماید.
      </p>
      <p className="text">
        تسویه حساب با پذیرنده مطابق با شرایط زیر انجام می‌شود:
      </p>
      <p className="text">
        آپولون کل مبلغ فروش پذیرنده از طریق درگاه اعتباری آپولون را تا پایان هر
        ماه محاسبه و پس از کسر کمیسیون و کارمزد در روز پنجم ماه بعد به شماره حساب
        معرفی شده پذیرنده در قرارداد واریز می‌نماید.
      </p>
      <p className="text">
        لازم به ذکر است در صورت تعطیل بودن موعد واریز، واریزی‌ها در اولین روز
        کاری بعد از تعطیلات به پذیرنده پرداخت خواهند شد.
      </p>
      <p className="text">مثال:</p>
      <p className="text">
        به طور مثال، مبلغ فروش یکم تا سی‌ام ماه مهرماه پذیرنده از طریق درگاه
        اعتباری آپولون، پس از کسر کمیسیون و کارمزد در یک مرحله و به ترتیب در
        تاریخ پنجم ماه آبان مطابق توضیح فوق به پذیرنده پرداخت می‌شود.
      </p>
      <p className="text">
        تبصره ۵: قابل ذکر است کلیه مبالغ دریافتی از مشتریان توسط آپولون، به صورت
        علی الحساب و به نیابت از پذیرنده است و جزو درآمدهای آپولون نمی‌باشد.
      </p>
      <p className="text">
        ۲-۶ پذیرنده شماره حساب{' '}
        <span className="font-bold">
          {placeholder(data?.bank_account_number)}
        </span>{' '}
        و به شماره شبا{' '}
        <span className="font-bold">{placeholder(data?.sheba_number)}</span>{' '}
        صادره از بانک{' '}
        <span className="font-bold">{placeholder(data?.bank_name)}</span> به نام{' '}
        <span className="font-bold">
          {placeholder(data?.bank_account_full_name)}
        </span>{' '}
        را جهت تسویه حساب مبالغ موضوع قرارداد معرفی کرد.
      </p>
    </Letterhead>
  )
}

export default Page2
